module.exports = __webpack_public_path__ + "assets/img/e0d0dea2cceb55ef49b5a0b804e986ac.png";